
import { Navigation as _Navigation, ASSET_TYPE, FWKIcons, sleep } from '@desp-aas/desp-ui-fwk';
import { helpRoutes, routes } from '../../utils/routes';
import { logoCollaborative, logoCollaborativeAlt, logoCollaborativeAlt2, serviceLogo } from '../../theme/images';


export default function Navigation() {
    return <_Navigation
        profileLink={"/user"}
        profileLabel="Welcome"
        // searchCallback={async()=>{ await sleep(1500) }}
        routes={routes}
        profileRoutes={[
            { id: "new_dataset", path: "/form/"  + ASSET_TYPE.dataset , label: <>New dataset</> },
            { id: "new_model", path: "/form/"  + ASSET_TYPE.model , label: <>New model</> },
            { id: "new_application", path: "/form/"  + ASSET_TYPE.application , label: <>New application</> },
            { id: "new_document", path: "/form/"  + ASSET_TYPE.paper , label: <>New document</> },
            { id: "new_course", path: "/form/"  + ASSET_TYPE.course , label: <>New course</> },
        ]}
        mobileThreshold={1130}
        helpRoutes={helpRoutes} 
        // serviceLogo={logoCollaborative}
        // serviceLogo={serviceLogo}
        // serviceLogo={logoCollaborativeAlt}
        serviceLogo={logoCollaborativeAlt2}
    />
}
